var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 83.3500 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7207-31.25L69.6777-31.25C71.7773-31.25 73.584-33.0566 73.584-35.2051C73.584-37.3535 71.7773-39.1602 69.6777-39.1602L13.7207-39.1602C11.5723-39.1602 9.76562-37.3535 9.76562-35.2051C9.76562-33.0566 11.5723-31.25 13.7207-31.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.68c68dbfe9b82ebc5c9e60f072247ad5.svg";
export { ForwardRef as ReactComponent };